import React, { useRef, useState, useEffect } from "react";
import {
  ArrowUpOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  RightOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import {
  Card,
  Col,
  Empty,
  Form,
  Input,
  message,
  Modal,
  Row,
  Spin,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { uniqBy } from "lodash";
import { useSelector } from "react-redux";
import { getAllDepartmentList } from "redux/selectors";
import AddEditTemplate from "./AddEditTemplate";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import dayjs from "dayjs";
import SuccessDeclinePopup from "reusableComponent/Popup/SuccessDeclinePopup";
const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
    padding-bottom: 10px;
  }
  .ant-modal-title {
    text-align: center;
    font-size: 15px;
    padding-top: 3%;
  }

  .ant-modal-footer {
    border: none;
  }
`;

const PRIMARY = "#2d53da";

const TemplateWrapper = styled.div`
  .breadcrumb {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .lite-text {
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }

  .ant-input-affix-wrapper,
  .ant-input,
  .ant-btn {
    border-radius: 24px;
  }

  .ant-select .ant-select-selector {
    border-radius: 24px;
  }

  .ant-input::placeholder {
    color: #000;
  }

  .ant-input:hover::placeholder {
    color: ${PRIMARY};
  }
  .ant-card-body {
    padding: 14px;
    height: -webkit-fill-available !important;
  }

  .template-card {
    border-radius: 14px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    height: 100%;
    background: #fff;
    border: 1px solid transparent;
  }

  .template-card:hover {
    border: 1px solid ${PRIMARY};
    background: #f5f8ff;
    cursor: pointer;
    // transform: translateY(-4px);
  }
  .template-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: -webkit-fill-available;
  }

  .title {
    font-weight: 600;
    font-size: 15px;
    color: #1f2937;
    transition: color 0.3s;
  }

  .updated {
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
    transition: color 0.3s;
  }

  .status-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 14px;
    font-size: 15px;
    color: ${PRIMARY};
    transition: color 0.3s;
  }
  .ant-tag {
    border-radius: 14px;
    font-weight: 500;
    padding: 2px 20px;
  }
`;

const Template = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const containerRef = useRef(null);
  const allDepartmentList = useSelector(getAllDepartmentList);
  const [loading, setLoading] = useState(false);

  const [dataList, setDataList] = useState([]);
  console.log("dataList", dataList);

  // Original data list with proper card structure

  const [filteredDataList, setFilteredDataList] = useState(dataList);
  console.log("filteredDataList", filteredDataList);
  const [isAddEditTemplate, setIsAddEditTemplate] = useState(false);
  const [status, setStatus] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [popupOpen, setPopupOpen] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { templates, code } = await CALL_API(
        `performance/performancetemplate/templates`,
        "get"
      );
      if (code === STATUS_CODE.SUCCESS) {
        setDataList(templates);
        setLoading(false);
      } else {
        throw new Error(`Failed to fetch data: ${code}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const uniqueDepartmentName = uniqBy(
    allDepartmentList?.map((item) => ({
      label: item?.department_name,
      value: item?.department_id,
    })),
    "value"
  );
  const deleteTemplate = async (id) => {
    const { code, message } = await CALL_API(
      `performance/templates/${id}`,
      "delete"
    );
    if (code === STATUS_CODE.SUCCESS) {
      if (message === "This template already has KPIs") {
        // Show error info modal — not deletable
        Modal.error({
          title:
            "You cannot delete this template as few open appraisal have been using this.",
          icon: (
            <div
              style={{
                background: "#ff4d4f",
                borderRadius: "50%",
                width: 36,
                height: 36,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: 20,
                fontWeight: "bold",
                margin: "0 auto 12px",
              }}
            >
              !
            </div>
          ),
          centered: true,
          okText: "Got it",
          okButtonProps: { type: "default" },
        });
      } else {
        setPopupOpen(true);
        setTimeout(() => {
          fetchData();
          setPopupOpen(false);
        }, 2000);
        setDeleteId("");
        setIsDelete(false);
      }
    }
  };

  const handleFormChange = () => {
    const formValues = form.getFieldsValue();
    const { name, type, department } = formValues;

    let filtered = [...dataList];

    // Filter by search name
    if (name && name.trim()) {
      filtered = filtered.filter((item) =>
        item?.templatename.toLowerCase().includes(name.toLowerCase())
      );
    }

    // Filter by status/type
    if (type && type.length > 0) {
      filtered = filtered.filter((item) => {
        if (type.includes("Draft") && item.statusid === "0") return true;
        if (
          type.includes("Active") &&
          item.templatestatus === "Active" &&
          item.statusid !== "0"
        )
          return true;
        if (
          type.includes("Inactive") &&
          item.templatestatus === "Inactive" &&
          item.statusid !== "0"
        )
          return true;
        return false;
      });
    }

    // Filter by department
    if (department && department.length > 0) {
      filtered = filtered.filter((item) =>
        item.availabledepartments.some((dept) => department.includes(dept))
      );
    }

    setFilteredDataList(filtered);
  };

  const statusTag = (status, statusid) => {
    if (statusid === "0") return <Tag color="blue">Draft</Tag>;
    if (status === "Inactive") return <Tag color="red">Inactive</Tag>;
    return <Tag color="green">Active</Tag>;
  };

  const handleClone = async (item) => {
    setLoading(true);

    const payload = {
      templatename: `Clone - ${item?.templatename}` || "",
      availabledepartments: item?.availabledepartments || [],
      templatestatus: item?.templatestatus || "",
      kpirole: item?.kpirole || [],
      mainquestionnairesection: item?.mainquestionnairesection || [],
      introductorysection: item?.introductorysection || [],
      remarkssection: item?.remarkssection || [],
      appraisermainquestionnairesection:
        item?.appraisermainquestionnairesection || [],
      appraiserintroductorysection: item?.appraiserintroductorysection || [],
      appraiserremarkssection: item?.appraiserremarkssection || [],
      scoreclassification: item?.scoreclassification || [],
      salaryincpercentage: item?.salaryincpercentage || [],
      updatedon: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      statusid: item?.statusid || "0",
    };

    console.log("payload-->", payload);
    const { code } = await CALL_API(
      `performance/performancetemplate`,
      "post",
      payload
    );

    if (code === STATUS_CODE.SUCCESS) {
      message.success("Template cloned successfully");
      fetchData();
    } else {
      message.error("Failed to clone template");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    handleFormChange();
  }, [dataList]);

  useEffect(() => {
    form.resetFields();
    handleFormChange();
  }, [isAddEditTemplate]);

  return (
    <TemplateWrapper>
      <>
        {!isAddEditTemplate && (
          <>
            <div className="breadcrumb">
              <p
                className="lite-text m-0 p-0"
                onClick={() => history.push("/performance", { id: "3" })}
              >
                Performance
              </p>
              &nbsp;
              <RightOutlined />
              &nbsp;
              <p className="m-0 p-0">Template</p>
            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
              <h6>Template</h6>
              <ButtonOutlined
                className="d-flex align-items-center"
                style={{ borderRadius: "5px" }}
                onClick={() => {
                  setIsAddEditTemplate(true);
                  setStatus("add");
                  setSelectedTemplate(null);
                }}
              >
                <PlusOutlined /> Add Template
              </ButtonOutlined>
            </div>

            <Form
              form={form}
              layout="vertical"
              onValuesChange={handleFormChange}
            >
              <Row gutter={16}>
                <Col xs={24} md={12} lg={8} xl={6} ref={containerRef}>
                  <Form.Item name="name">
                    <Input
                      placeholder="Search"
                      prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={8} xl={6}>
                  <DropdownCheckBox
                    name="type"
                    label="Type"
                    options={[
                      { label: "Active", value: "Active" },
                      { label: "Inactive", value: "Inactive" },
                      { label: "Draft", value: "Draft" },
                    ]}
                    className="input_field"
                    customStyle
                    form={form}
                  />
                </Col>

                <Col xs={24} md={12} lg={8} xl={6}>
                  <DropdownCheckBox
                    name="department"
                    label="Department"
                    options={uniqueDepartmentName}
                    className="input_field"
                    customStyle
                    form={form}
                  />
                </Col>
              </Row>
            </Form>
            {/* Cards */}
            <Spin spinning={loading}>
              {filteredDataList.length === 0 ? (
                <Empty />
              ) : (
                <Row gutter={[16, 16]}>
                  {filteredDataList?.map((item, index) => (
                    <Col key={item.id} xs={24} md={12} lg={8}>
                      <Card
                        bordered={false}
                        className={`template-card`}
                        onClick={(e) => {
                          if (item.statusid !== "0") {
                            e.stopPropagation();
                            setSelectedTemplate(item);
                            setIsAddEditTemplate(true);
                            setStatus("view");
                          }
                        }}
                      >
                        <div className="template-content">
                          <div>
                            <div className="title">{item.templatename}</div>
                            <div className="updated">
                              Last Update on:{" "}
                              {dayjs(item.updatedon).format("Do MMM YYYY")}
                            </div>
                          </div>

                          <div className="status-row">
                            {statusTag(item.templatestatus, item?.statusid)}

                            <div className="actions">
                              {item.statusid === "0" ? (
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedTemplate(item);
                                    setIsAddEditTemplate(true);
                                    setStatus("draft");
                                  }}
                                >
                                  <ArrowUpOutlined /> Complete
                                </span>
                              ) : (
                                <>
                                  <Tooltip title="Copy">
                                    <CopyOutlined
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleClone(item);
                                      }}
                                    />
                                  </Tooltip>
                                  <Tooltip title="Edit">
                                    <EditOutlined
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedTemplate(item);
                                        setIsAddEditTemplate(true);
                                        setStatus("edit");
                                      }}
                                    />
                                  </Tooltip>
                                  <Tooltip title="Delete">
                                    <DeleteOutlined
                                      style={{ cursor: "pointer" }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        Modal.confirm({
                                          title:
                                            "Are you sure you want to delete this Category?",
                                          icon: null,
                                          centered: true,
                                          okText: "Yes",
                                          cancelText: "No",
                                          okButtonProps: { type: "primary" },
                                          onOk: () =>
                                            deleteTemplate(item?.templateid),
                                        });
                                      }}
                                    />
                                    {/* <DeleteOutlined
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setDeleteId(item?.templateid);
                                      setIsDelete(true);
                                      // Add delete logic here
                                    }}
                                  /> */}
                                  </Tooltip>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              )}
            </Spin>
          </>
        )}
        {isAddEditTemplate && (
          <AddEditTemplate
            setIsAddEditTemplate={setIsAddEditTemplate}
            isAddEditTemplate={isAddEditTemplate}
            status={status}
            setStatus={setStatus}
            dataList={selectedTemplate}
            fetchData={fetchData}
          />
        )}
      </>

      <StyledModal
        open={isDelete}
        onOk={() => deleteTemplate(deleteId)}
        okText={"Yes"}
        cancelText={"No"}
        onCancel={() => {
          setDeleteId("");
          setIsDelete(false);
        }}
        closable={false}
      >
        <Typography.Title className="p-2" level={5}>
          Are you sure you want to delete this category?
        </Typography.Title>
      </StyledModal>
      <SuccessDeclinePopup
        open={popupOpen}
        setOpen={setPopupOpen}
        type="success"
        message="Deleted"
      />
    </TemplateWrapper>
  );
};

export default Template;
